import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublishDialogComponent } from './publish-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

const PIPES = []!;

const ANGULAR_MATERIAL_MODULES = [
  MatDialogModule, MatFormFieldModule, MatInputModule,
  MatChipsModule, MatButtonModule, MatIconModule,
  MatAutocompleteModule, MatSelectModule, MatSlideToggleModule,
  MatCheckboxModule
];

const CORE_MODULES = [CommonModule, ReactiveFormsModule, FormsModule, RouterModule];

const COMPONENTS = [PublishDialogComponent];

@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [...CORE_MODULES, ...ANGULAR_MATERIAL_MODULES],
  exports: [...COMPONENTS]
})
export class PublishDialogModule { }
